import { forwardRef, useState, type ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

import { FontIcon } from '@/shared/ui/atoms/FontIcon';
import { Input } from '@/shared/ui/atoms/Input';
import './PasswordInput.styl';

type Props = Omit<ComponentProps<typeof Input>, 'type' | 'leading' | 'trailing'>;

/** Password field with a lock glyph and a show/hide toggle. */
export const PasswordInput = forwardRef<HTMLInputElement, Props>(function PasswordInput(props, ref) {
  const { t } = useTranslation(undefined, { keyPrefix: 'common' });
  const [visible, setVisible] = useState(false);
  return (
    <Input
      ref={ref}
      {...props}
      type={visible ? 'text' : 'password'}
      leading={<FontIcon name="lock4" />}
      trailing={
        <button
          type="button"
          className="m-password__toggle"
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? t('hidePassword') : t('showPassword')}
          aria-pressed={visible}
          disabled={props.disabled}
        >
          <FontIcon name={visible ? 'eye-blocked3' : 'eye3'} />
        </button>
      }
    />
  );
});
